module.exports = __webpack_public_path__ + "static/media/DrDeepaPrakash.2707fd98.png";